import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

export enum LogLevel {
  DEBUG = 0,
  INFO = 1,
  WARN = 2,
  ERROR = 3
}

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  private readonly logLevel: LogLevel;

  constructor() {
    this.logLevel = environment.production ? LogLevel.WARN : LogLevel.ERROR;
  }

  debug(message: string, ...optionalParams: unknown[]): void {
    this.log(LogLevel.DEBUG, message, optionalParams);
  }

  info(message: string, ...optionalParams: unknown[]): void {
    this.log(LogLevel.INFO, message, optionalParams);
  }

  warn(message: string, ...optionalParams: unknown[]): void {
    this.log(LogLevel.WARN, message, optionalParams);
  }

  error(message: string, error?: Error | unknown, ...optionalParams: unknown[]): void {
    this.log(LogLevel.ERROR, message, [error, ...optionalParams]);
  }

  private log(level: LogLevel, message: string, params: unknown[]): void {
    if (level < this.logLevel) {
      return;
    }

    const timestamp = new Date().toISOString();
    const levelString = LogLevel[level];
    const formattedMessage = `[${timestamp}] [${levelString}] ${message}`;

    switch (level) {
      case LogLevel.DEBUG:
        // eslint-disable-next-line no-console
        console.debug(formattedMessage, ...params);
        break;
      case LogLevel.INFO:
        // eslint-disable-next-line no-console
        console.info(formattedMessage, ...params);
        break;
      case LogLevel.WARN:
        // eslint-disable-next-line no-console
        console.warn(formattedMessage, ...params);
        break;
      case LogLevel.ERROR:
        // eslint-disable-next-line no-console
        console.error(formattedMessage, ...params);
        break;
    }

    // In production, you could send logs to a remote service here
    // Example: if (environment.production && level >= LogLevel.ERROR) {
    //   this.sendToRemoteLoggingService(level, message, params);
    // }
  }
}
